// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-info {
  padding: 5%;
  background: #f3f4f6;
}
.payment-info__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
  padding-left: 20%;
}
.payment-info__top {
  padding-left: 20%;
  padding-right: 20%;
}
.payment-info__labels {
  display: flex;
  height: 50px;
}
.payment-info__labels__button {
  margin-left: auto;
}
.payment-info__labels__label {
  margin-right: 10px;
}
.payment-info__table__tr {
  display: flex;
  margin-top: 10px;
}
.payment-info__table__td {
  width: 130px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #999999;
}
.payment-info__table__value {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  display: flex;
}
.payment-info__bottom {
  padding-left: 20%;
  padding-right: 20%;
  margin-top: 30px;
}
.payment-info__bottom__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #333333;
}
.payment-info__content {
  background: white;
  margin-top: 20px;
  padding: 5%;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
}
.payment-info__content-head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #333333;
}
.payment-info__content-body {
  margin-top: 20px;
}
.payment-info__content-info {
  margin-top: 20px;
}
.payment-info__text {
  display: flex;
}

.left-column {
  width: 30%;
}

.period-of-use,
.payment-amount,
.next-payment-date,
.means-of-payment {
  color: #b4b9bf;
}
.period-of-use__info,
.payment-amount__info,
.next-payment-date__info,
.means-of-payment__info {
  color: #566370;
}

.fonts {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
}

.means-of-payment {
  display: flex;
}

.change-payment-type {
  margin-left: 10px;
  cursor: pointer;
  border: 1px solid #d6e7e4;
  border-radius: 6px;
  padding: 3px 8px 3px 8px;
  background: #e5f4f2;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #49ae9e;
}

.change-of-plan {
  display: flex;
  background: #f8f9f9;
}
.change-of-plan__button {
  margin-top: 30px;
}

.right-column {
  width: 75%;
  padding: 30px;
}

.payment-details__table {
  margin-top: 25px;
  border-collapse: collapse;
  width: 100%;
}
.payment-details__tr {
  text-align: center;
  height: 70px;
  color: #505054;
  border-bottom: 1px solid #dfdfdf;
}
.payment-details__td {
  text-align: center;
  color: #868686;
  border-top: 1px solid #868686;
}
.payment-details__td-bold {
  text-align: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}

.payment-icons {
  margin-top: 2px;
  margin-right: 4px;
}

.text-button {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/screens/payment/payment-info/payment-info.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,mBAAA;AACJ;AACI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AACR;AAEI;EACI,iBAAA;EACA,kBAAA;AAAR;AAGI;EACI,aAAA;EACA,YAAA;AADR;AAGQ;EACI,iBAAA;AADZ;AAIQ;EACI,kBAAA;AAFZ;AAOQ;EACI,aAAA;EACA,gBAAA;AALZ;AAQQ;EACI,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AANZ;AASQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AAPZ;AAWI;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;AATR;AAWQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AATZ;AAaI;EACI,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,4CAAA;AAXR;AAcI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAZR;AAeI;EACI,gBAAA;AAbR;AAgBI;EACI,gBAAA;AAdR;AAiBI;EACI,aAAA;AAfR;;AAmBA;EACI,UAAA;AAhBJ;;AAmBA;;;;EAII,cAAA;AAhBJ;AAkBI;;;;EACI,cAAA;AAbR;;AAiBA;EACI,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAdJ;;AAiBA;EACI,aAAA;AAdJ;;AAiBA;EACI,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAfJ;;AAkBA;EACI,aAAA;EACA,mBAAA;AAfJ;AAiBI;EACI,gBAAA;AAfR;;AAmBA;EACI,UAAA;EACA,aAAA;AAhBJ;;AAoBI;EACI,gBAAA;EACA,yBAAA;EACA,WAAA;AAjBR;AAoBI;EACI,kBAAA;EACA,YAAA;EACA,cAAA;EACA,gCAAA;AAlBR;AAqBI;EACI,kBAAA;EACA,cAAA;EACA,6BAAA;AAnBR;AAsBI;EACI,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AApBR;;AAwBA;EACI,eAAA;EACA,iBAAA;AArBJ;;AAwBA;EACI,aAAA;AArBJ","sourcesContent":[".payment-info {\n    padding: 5%;\n    background: #f3f4f6;\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 28px;\n        line-height: 38px;\n        color: #333333;\n        padding-left: 20%;\n    }\n\n    &__top {\n        padding-left: 20%;\n        padding-right: 20%;\n    }\n\n    &__labels {\n        display: flex;\n        height: 50px;\n\n        &__button {\n            margin-left: auto;\n        }\n\n        &__label {\n            margin-right: 10px;\n        }\n    }\n\n    &__table {\n        &__tr {\n            display: flex;\n            margin-top: 10px;\n        }\n\n        &__td {\n            width: 130px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            color: #999999;\n        }\n\n        &__value {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #333333;\n            display: flex;\n        }\n    }\n\n    &__bottom {\n        padding-left: 20%;\n        padding-right: 20%;\n        margin-top: 30px;\n\n        &__head {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 20px;\n            line-height: 30px;\n            color: #333333;\n        }\n    }\n\n    &__content {\n        background: white;\n        margin-top: 20px;\n        padding: 5%;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n    }\n\n    &__content-head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 24px;\n        color: #333333;\n    }\n\n    &__content-body {\n        margin-top: 20px;\n    }\n\n    &__content-info {\n        margin-top: 20px;\n    }\n\n    &__text {\n        display: flex;\n    }\n}\n\n.left-column {\n    width: 30%;\n}\n\n.period-of-use,\n.payment-amount,\n.next-payment-date,\n.means-of-payment {\n    color: #b4b9bf;\n\n    &__info {\n        color: #566370;\n    }\n}\n\n.fonts {\n    font-family: 'Noto Sans KR';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n}\n\n.means-of-payment {\n    display: flex;\n}\n\n.change-payment-type {\n    margin-left: 10px;\n    cursor: pointer;\n    border: 1px solid #d6e7e4;\n    border-radius: 6px;\n    padding: 3px 8px 3px 8px;\n    background: #e5f4f2;\n\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    text-align: center;\n    color: #49ae9e;\n}\n\n.change-of-plan {\n    display: flex;\n    background: #f8f9f9;\n\n    &__button {\n        margin-top: 30px;\n    }\n}\n\n.right-column {\n    width: 75%;\n    padding: 30px;\n}\n\n.payment-details {\n    &__table {\n        margin-top: 25px;\n        border-collapse: collapse;\n        width: 100%;\n    }\n\n    &__tr {\n        text-align: center;\n        height: 70px;\n        color: #505054;\n        border-bottom: 1px solid #dfdfdf;\n    }\n\n    &__td {\n        text-align: center;\n        color: #868686;\n        border-top: 1px solid #868686;\n    }\n\n    &__td-bold {\n        text-align: center;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n    }\n}\n\n.payment-icons {\n    margin-top: 2px;\n    margin-right: 4px;\n}\n\n.text-button {\n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
